var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.notification.category === 'new_shared_item')?_c(_setup.SharedItemNotification,{attrs:{"notification":_setup.props.notification}}):_c(_setup.MessageNotification,{attrs:{"options":{ notification: _setup.props.notification }}})
}
var staticRenderFns = []

export { render, staticRenderFns }